import { TagViewModel } from "./Tags.types";
import { useState } from "react";

import { useDotLegalQuery, useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";

export function useTags() {
    const [showTagDialog, setShowTagDialog] = useState(false);
    const [selectedTag, setSelectedTag] = useState<TagViewModel | undefined>(undefined);
    const [showDeleteTagDialog, setShowDeleteTagDialog] = useState<TagViewModel | undefined>(undefined);

    const { isLoading, data, refetch } = useDotLegalQueryWithKey<Array<TagViewModel>>("tags", "/Tag");

    const onTagSave = () => {
        setSelectedTag(undefined);
        setShowTagDialog(false);
        refetch();
    };

    const onTagDeleted = () => {
        setShowDeleteTagDialog(undefined);
        refetch();
    };

    return {
        isLoading,
        data,
        showTagDialog,
        setShowTagDialog,
        selectedTag,
        setSelectedTag,
        onTagSave,
        showDeleteTagDialog,
        setShowDeleteTagDialog,
        onTagDeleted,
    };
}
